var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useRef, useState } from "react";
var useToastQueue = function (max, duration) {
    if (max === void 0) { max = 3; }
    if (duration === void 0) { duration = 2500; }
    var _a = useState([]), toasts = _a[0], setToasts = _a[1];
    var nextId = useRef(0);
    var push = function (message) {
        var id = nextId.current++;
        setToasts(function (prev) {
            var visible = prev.filter(function (t) { return t.open; });
            var next = __spreadArray(__spreadArray([], prev, true), [{ id: id, message: message, open: true }], false);
            if (visible.length >= max) {
                var oldestId_1 = visible[0].id;
                next = next.map(function (t) { return (t.id === oldestId_1 ? __assign(__assign({}, t), { open: false }) : t); });
            }
            return next;
        });
        setTimeout(function () {
            setToasts(function (prev) { return prev.map(function (t) { return (t.id === id ? __assign(__assign({}, t), { open: false }) : t); }); });
        }, duration);
    };
    var remove = function (id) {
        setToasts(function (prev) { return prev.filter(function (t) { return t.id !== id; }); });
    };
    return { toasts: toasts, push: push, remove: remove };
};
export default useToastQueue;
